import React, { Component } from "react";
import styles from "./css/Footer.module.css";

export class Footer extends Component {
  render() {
    return (
      <div className={styles.footerCont}>
        <div className={styles.footerContInner}>
          <div className={styles.infoBlock}>
            <div className={styles.block12}>
              <div className={styles.block1}>
                <div className={styles.block1Inner}>
                  <div className={styles.logoCont}>
                    <img src="/assets/logo/allpromana.png" />
                  </div>
                  <div className={styles.introStm}>
                    <span>
                      3DCape & AllPromana works with do grow network of
                      professional, giving them all the technical support that
                      they need to be successful.
                    </span>
                  </div>
                </div>
              </div>
              <div className={styles.block2}>
                <div className={styles.block2Inner}>
                  <ul>
                    <li>
                      <a href="/about" target="_blank">
                        <span>About Us</span>
                      </a>
                    </li>
                    <li>
                      <a href="/blog" target="_blank">
                        <span>Blog</span>
                      </a>
                    </li>
                    <li>
                      <a href="/faq" target="_blank">
                        <span>FAQ</span>
                      </a>
                    </li>
                    <li>
                      <a href="/faq" target="_blank">
                        <span>Terms & Conditions</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className={styles.block34}>
              <div className={styles.block4}>
                <div className={styles.block4Inner}>
                  <div className={styles.followUs}>
                    <p>Follow Us</p>
                  </div>
                  <div className={styles.socialIcons}>
                    <div className={styles.icon}>
                      <img src="/assets/icons/facebook.svg" />
                    </div>
                    <div className={styles.icon}>
                      <img src="/assets/icons/twitter.svg" />
                    </div>
                    <div className={styles.icon}>
                      <img src="/assets/icons/linkedin.svg" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.copyRightBlock}>
          <p>Copyright 2022 All Rights Reserved. 3DCape.</p>
        </div>
      </div>
    );
  }
}

export default Footer;
